export const environment = {
  production: true,
  buildId: '3092229067220421',
  configFile: 'config.json',
};
